import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BreadcrumbItem } from './breadcrumbs.component';

@Injectable({ providedIn: 'root' })
export class PageBreadcrumbService {
  private readonly extraItems$ = new BehaviorSubject<BreadcrumbItem[]>([]);
  readonly items$ = this.extraItems$.asObservable();

  set(items: BreadcrumbItem[]): void {
    this.extraItems$.next(items ?? []);
  }

  clear(): void {
    this.extraItems$.next([]);
  }
}
